<div class="modal-header">
  <h5 class="modal-title">File Upload</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  
  <!-- File list (success case) -->
  <div *ngIf="files && !uploadFailed">
    <div *ngFor="let file of files" class="mb-1">
      {{file.name}}
    </div>
  </div>

  <!-- Failed files -->
  <div *ngIf="failedFiles && uploadFailed">
    <h5 class="text-danger">The following files failed to upload:</h5>
    <div class="alert alert-danger" *ngFor="let file of failedFiles">
      <strong>{{file.name}}</strong> - {{file.error}}
    </div>
  </div>

  <!-- Existing files warning -->
  <div *ngIf="existingFiles.length > 0" class="alert alert-warning mt-3">
    <div class="d-flex align-items-start">
      <fa-icon [icon]="faExclamationCircle" class="text-warning me-2" size="lg"></fa-icon>
      <div>
        <strong>Warning:</strong> The following files will be overwritten (may include archived files):
        <ul class="mt-2 mb-0">
          <li *ngFor="let file of existingFiles">{{file}}</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">

  <button *ngIf="!uploading && !uploadFailed" 
          type="button" 
          class="btn btn-success" 
          (click)="uploadFiles()">
    Upload Files
  </button>

  <button *ngIf="uploading && !uploadFailed" 
          type="button" 
          class="btn btn-success" 
          disabled>
    <span class="spinner-border spinner-border-sm me-2"></span>
    Uploading...
  </button>
</div>